/** "2 documents, 1 contact, 3 notes" — only the non-zero parts. */
export function describePending(documents: number, contacts: number, notes = 0): string {
  const parts = nonZeroParts(documents, contacts, notes);
  return parts.length === 0 ? 'Nothing — all changes are on Mon Ami' : parts.join(', ');
}

/**
 * "2 documents, 1 contact and 3 notes" for the success banner, or null when nothing was
 * left behind by the last push sweep.
 */
export function describeLeftBehind(documents: number, contacts: number, notes = 0): string | null {
  const parts = nonZeroParts(documents, contacts, notes);
  if (parts.length === 0) return null;
  return parts.length === 1 ? parts[0] : `${parts.slice(0, -1).join(', ')} and ${parts[parts.length - 1]}`;
}

function nonZeroParts(documents: number, contacts: number, notes: number): string[] {
  const parts: string[] = [];
  if (documents > 0) parts.push(plural(documents, 'document'));
  if (contacts > 0) parts.push(plural(contacts, 'contact'));
  if (notes > 0) parts.push(plural(notes, 'note'));
  return parts;
}

function plural(count: number, noun: string): string {
  return `${count} ${noun}${count === 1 ? '' : 's'}`;
}
